import { Router } from '@angular/router';
import { AuthService } from 'lib-auth';
import { TranslateService } from '@ngx-translate/core';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';

export class AbstractAppRootComponent {

    protected constructor(private router: Router,
                          private authService: AuthService,
                          translateService: TranslateService,
                          environment: { publicApiUrl: string, authClientId: string }) {
        console.log('root - init app');
        authService
            .configure(environment.publicApiUrl, environment.authClientId)
            .subscribe(_ => console.log('connected user', this.authService.getUser()));
        translateService.setDefaultLang('');
        translateService.use('');
        registerLocaleData(localeFr);
    }
}
